import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbSharepoint: BowlBlock = withIntegration(options.slug.llmKbSharepoint, [
  {
    name: 'clientId',
    type: 'withText',
  },
  {
    name: 'clientSecret',
    type: 'withText',
  },
  {
    name: 'tenantId',
    type: 'withText',
    required: false,
  },
  {
    name: 'siteUrl',
    type: 'withText',
  },
  {
    name: 'sitePath',
    type: 'withText',
    required: false,
  },
  {
    name: 'recursive',
    type: 'checkbox',
    required: false,
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
    required: false,
  },
]);
